// extracted by mini-css-extract-plugin
export default {"main":"AIMarkingLinePartition_main__n+vzK","heading":"AIMarkingLinePartition_heading__S2lKO"};